import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-ruolo-dettaglio',
  templateUrl: './ruolo-dettaglio.component.html',
  styleUrls: ['./ruolo-dettaglio.component.css']
})
export class RuoloDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  public isEdit: number = 0

  constructor(public dialogRef: MatDialogRef<RuoloDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Ruolo'
  }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      idUtenteProfiloRuolo: [null],
      RuoloProfilo: [null],
      Visibile: [null]
    })

    if (this.data.iValore >= -2) {
      // console.log('ivalore modale', this.data.iValore)
      this.getDettaglio(this.data.iValore)
      this.isEdit = 1;
    }
    if (this.data.iValore == -2){
      this.titolo = this.titolo + ' - Inserimento ';
      this.isEdit = 0;
    }

  }

  getDettaglio(iValore: number) {
    this.srvUtilita.getObj('Utenti/GetUtentiProfiloRuoloListaDettaglio?idUtenteProfiloRuolo=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      //console.log(res, 'res')
      this.frmInserimento.patchValue(this.objdettaglio)
      this.titolo = this.titolo + ": " + this.objdettaglio.RuoloProfilo
    })
  }


  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    if (objInserimento.Visibile == true) {
      objInserimento.Visibile = 1
    } else {
      objInserimento.Visibile = 0
    }
    /*
    if (this.data.iValore > 0) {
      objInserimento.idAteneo = this.data.iValore
    } else { objInserimento.idAteneo = 0; }
    */

    const obj = {
      idUtenteProfiloRuolo: this.data.iValore,
      RuoloProfilo: objInserimento.RuoloProfilo,
      Visibile: objInserimento.Visibile
    }


    this.srvUtilita.postObj('Utenti/PostRuolo', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}

